import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'backgroundfy'})
export class BackgroundfyPipe implements PipeTransform {
    transform(string: string): string {
        return `url('${string}')`;
    }
}
